import React, {useContext, useState} from 'react';
import {BeatLoader} from "react-spinners";
import {FormattedMessage} from "react-intl";

import markAllAsRead from "api/notification/markAllAsRead";

import {blue500, red500} from "assets/jss/main";

import deleteAll from "api/notification/deleteAll";

import {NotificationContext} from "../../../../../NotificationContext";
import {SidebarContext} from "../../../../../../../../../../../SidebarContext";

function NotificationHeaderAction() {
    const [loading, setLoading] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const {currentMember} = useContext(SidebarContext);

    const {
        selectedNavigationToggle,
        reloadNotifications,
        notificationsCount,
        notificationsViewedCount,
        notificationsToDisplay
    } = useContext(NotificationContext);

    const canDeleteAll = selectedNavigationToggle === 1 || (selectedNavigationToggle === 0 && notificationsCount === notificationsViewedCount);

    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                fontSize: '12px',
                color: canDeleteAll ? red500 : blue500,
                cursor: 'pointer',
                textDecoration: isHovered ? 'underline' : 'none'
            }}
        >
            {loading ? (
                <BeatLoader size={4} color={blue500} />
            ) : notificationsToDisplay.length === 0 ? null : canDeleteAll ? (
                <div onClick={() => {
                    setLoading(true);
                    deleteAll(currentMember.id)
                        .then(() => reloadNotifications())
                        .finally(() => setLoading(false))
                }}>
                    <FormattedMessage id='sidebar.profil.notification.menu.action.deleteAll' />
                </div>
            ) : (
                <div onClick={() => {
                    setLoading(true)
                    markAllAsRead(currentMember.id)
                        .then(() => reloadNotifications())
                        .finally(() => setLoading(false))
                }}>
                    <FormattedMessage id='sidebar.profil.notification.menu.action.markAllAsRead' />
                </div>
            )}
        </div>
    );
}

export default NotificationHeaderAction;
